/* @flow */
import Chat from 'entities/Chat';
import ChatWelcomeMessage from 'chat/components/ChatWelcomeMessage.jsx';
import Group from 'entities/Group';
import Link from 'components/Link.jsx';
import React from 'react';
import { EVERYONE, subgroupName } from 'utils/roleHelpers';

export class MessageListWelcome extends React.PureComponent {
  props: {
    chat?: ?Chat,
    group?: ?Group,
    subgroupRole?: ?string,
  };

  makeHeaders() {
    const { chat, group, subgroupRole } = this.props;
    if (group) {
      const messageSettingsLink = (<Link to="/settings/chat">message settings</Link>);
      const subgrouped = subgroupRole && subgroupRole !== EVERYONE;
      // $FlowIssue can't infer that role is defined
      const target = subgrouped ? `${subgroupRole}s in ${group.getName()}` : group.getName();
      // $FlowIssue can't infer that role is defined
      const membershipDescription = subgrouped ? 'Participants' : subgroupName[subgroupRole];

      return {
        firstHeader: `This is the beginning of your announcement history for ${target}.`,
        secondHeader: (
          <div>
            {membershipDescription} in your class can receive announcements by text, app, web, and email.
            They can also reply directly to you depending on your {messageSettingsLink}.
          </div>
        ),
      };
    } else if (chat) {
      const otherMember = chat.getOtherMember();
      const subject = otherMember && otherMember.id !== -1 ?
        otherMember.name : 'Participants';
      const title = chat.hasTitle() ?
        chat.getTitle() : chat.getDisplayNames().join(', ');

      return {
        firstHeader: (
          <div>
            This is the beginning of your message history with {title}.
          </div>
        ),
        secondHeader: `${subject} can send and receive messages by text, app, web, and email.`,
      };
    } else {
      return { firstHeader: null, secondHeader: null };
    }
  }

  render() {
    const { chat } = this.props;
    const heroImage = require('assets/images/chat-welcome-hero.png');

    if (chat && chat.isActivityType()) {
      return null;
    }

    const { firstHeader, secondHeader } = this.makeHeaders();

    return (
      <ChatWelcomeMessage
        chat={chat}
        firstHeader={firstHeader}
        secondHeader={secondHeader}
        heroImage={heroImage}
        className="MessageList-welcomeMessage"
      />
    );
  }
}

export default MessageListWelcome;



// WEBPACK FOOTER //
// ./src/chat/components/MessageListWelcome.jsx